import { Store, GetterTree, MutationTree, ActionTree, Module } from "vuex";

import { RootState } from "..";
import { IContentTemplateState } from "../states/content-template-state";
import { contentTemplateService } from "../../services/content-template.service";
import { IContentTemplate } from "../../models/interfaces/content/content-template.model.interface";
import { ContentTemplateModel } from "../../models/content/content-template.model";

export const state: IContentTemplateState = {
    template: new ContentTemplateModel()
};

export const getters: GetterTree<IContentTemplateState, RootState> = {
    template(state) {
        return state.template;
    }
};

export const mutations: MutationTree<IContentTemplateState> = {
    template(state, template) {
        state.template = template;
      }
};

export const actions: ActionTree<IContentTemplateState, RootState> = {
    async createTemplate({ commit }, template: IContentTemplate) {
        return new Promise((resolve) => {
            contentTemplateService.Create(template)
                .then((value) => {
                    if (value.success) {
                        commit("template", value.result);
                        resolve(value.success);
                    } else {
                        resolve(false);
                    }
                });
        });
    },
    async retrieveTemplate({ commit }, id: number) {
        return new Promise((resolve) => {
            contentTemplateService.Get(id)
            .then((value) => {
                commit("template", value.result);
                resolve(value.success);
            });
        });
    },
    async updateTemplate({ dispatch, commit }, template: IContentTemplate) {
        return new Promise((resolve) => {
            contentTemplateService.Update(template)
                .then((value) => {
                    if (value) {
                        commit("template", template);
                        dispatch("contentSetVersionModule/retrieveConfigurationVersion", null, { root: true }).then((value) => {
                            resolve(true);
                        });
                    } else {
                        resolve(false);
                    }
                });
        });
    },
};

export const contentTemplateModule: Module<IContentTemplateState, RootState> = {
    state, getters, mutations, actions, namespaced: true
};
